import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[orgbrain-tab]',
  standalone: false,
})
export class OrgbrainTabDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input() icon: string;
  @Input() class = '';
  @Input() tabWindowClassOverride = '';
  @Input() label: string = 'placeholderlabel';
  @Input() notifications: string | number;
  @Input() id: string = '';
  @Input() show: boolean = true;
  @Input() highlighted: boolean = false;
}
